import { IconLoading } from "../config/icons";
import { components } from "../config/testIds";

const Loading = () => {
  return (
    <div className="box" data-testid={components.loading}>
      {IconLoading}
    </div>
  );
};

export default Loading;
